<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <SpeedStartCheckout :combos="combos" :variant="variant" :upsellCombo="upsellCombo" :includeSubscription="includeSubscription"/>
  </b-container>
</template>
<style>

</style>

<script>
import SpeedStartCheckout from "@/components/checkout/speedstart/SpeedStartCheckout.vue";

export default {
  title: 'Speed Start Checkout',
  name: "SpeedStart",
  props: ["combos", "upsellCombo", "includeSubscription"],
  components: {
    SpeedStartCheckout
  },
  computed: {
    variant: function () {
      var q = this.$route.query;
      if (q && "v" in q && ["A", "B", "C"].includes(q["v"])) {
        let variant = q["v"];
        q = Object.assign({}, this.$route.query);
        delete q.v;
        this.$router.replace({ q });
        localStorage.setItem("speed-start-variant", variant);
        return variant;
      } else {
        let variant = localStorage.getItem("speed-start-variant");        
        return variant ? variant : "A";
      }
    },
  },
};
</script>
